import {Provider} from '@angular/core';
import {DOMAIN_SUBSCRIBERS} from "../../../booking/domain/tokens/booking.tokens";
import {
  UpdateSerieOnTicketGeneratedSubscriber
} from "../../application/subscribers/update-serie-on-ticket-generated.subscriber";

export const PAYMENT_LEGACY_PROVIDERS: Provider[] = [
  {
    provide: DOMAIN_SUBSCRIBERS,
    useClass: UpdateSerieOnTicketGeneratedSubscriber,
    multi: true
  },
];
